"use client";

import { useEffect, useRef } from "react";
import { AspectRatio } from "react-aspect-ratio";
import videojs from "video.js";
import styles from "./styles.module.scss";

export const VideosSet = ({
    video,
    autoplay = true,
    controls = false,
    loop = true,
    field = "_url",
    width = 1920,
    height = 813,
}: any) => 
{
    const videoRef = useRef<any>(null);
    const playerRef = useRef<any>(null);

    useEffect(() => 
    {
        const initializePlayer = async () => 
        {
            if (video && videoRef.current) 
            {
                const hlsSource = {
                    src  : video[field], // HLS (m3u8)
                    type : "application/x-mpegURL",
                };

                const mp4Source = {
                    src  : video.mp4,
                    type : "video/mp4",
                };

                // 🚨 Força atributos essenciais direto no vídeo DOM
                videoRef.current.muted = true;
                videoRef.current.autoplay = true;
                videoRef.current.playsInline = true;

                playerRef.current = videojs(videoRef.current, {
                    controls    : controls,
                    autoplay    : autoplay,
                    muted       : true,
                    loop        : loop,
                    playsinline : true,
                    preload     : "metadata",
                    poster      : video.thumb,
                    html5       : {
                        hls : {
                            overrideNative               : true,
                            smoothQualityChange          : true,
                            useBandwidthFromLocalStorage : true,
                        },
                    },
                    sources   : [ hlsSource, mp4Source ],
                    language  : "en",
                    languages : {
                        en : {
                            "Video Player is loading" : "...",
                        },
                    },
                });

                playerRef.current.on("error", () => 
                {
                    const error = playerRef.current?.error();
                    console.warn("Erro ao carregar HLS:", error);

                    if (error?.code === 4) 
                    {
                        console.log("Tentando fallback para MP4");
                        playerRef.current.src(mp4Source);
                        playerRef.current.load();
                        playerRef.current.play().catch((err: any) => 
                        {
                            console.error("Erro ao reproduzir fallback MP4:", err);
                        });
                    }
                });
            }
        };

        initializePlayer();

        return () => 
        {
            // if (playerRef.current) {
            //   playerRef.current.dispose();
            // }
        };
    }, [ video ]);

    return (
        <div className={styles.videosSet}>
            <AspectRatio ratio={width / height}>
                <div className={styles.videoContent}>
                    <video
                        ref={videoRef}
                        className={styles.player}
                        controls
                        preload="auto"
                        width="100%"
                        height="100%"
                        muted
                        playsInline
                        autoPlay
                        poster="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
                    />
                </div>
            </AspectRatio>
        </div>
    );
};